let english = {
  //NAVBAR
  projects: 'PROJECTS',
  exportlinks: 'EXPORT LINKS',
  //VIDEOLIST
  newvideos: 'New VOD(s)',
  newlive: 'New Live',
  helpwsearch: 'Help with searchbar',
  helpwsearchtxt: 'Filter on <b>title</b> and <b>tags</b> by default (if no keyword mentioned). <br /><br />Keywords for specific search are: <b>title</b>, <b>tags</b>, <b>id</b>, <b>status</b>, <b>description</b>. <br /><br /> Use "<b>+</b>" to cumulate several parameters for one keyword.<br /> Ex: tags:football<b>+</b>tennis. <br /><br />Use a <b>space</b> to make a search combining more than one criteria. <br />Ex: title:MyMovie tags:vacation+summer.',
  filter: 'Filter',
  result: 'Result',
  imbmode: 'Imbricated view mode',
  imbmodetxt: 'The <strong>VOD archives</strong> from your lives and the <strong>Cut-versions</strong> created from your videos are displayed in an imbricated mode and in smaller size to ease the visualisation. <br />It is not possible to sort and filter on them in imbricated view mode. <br /> The sorts and filters are only applied to Live and VOD original streams.<br /> In order to apply sorting or filtering on all videos, disable imbricated view mode.',
  perpage: 'per page',
  selectsort: 'Select the element to "sort by" in the list below (scroll right/left).',
  title: 'Title',
  author: 'Author',
  creationdate: 'Creation date',
  duration: 'Duration',
  modifdate: 'Modification date',
  status: 'Status',
  errors: 'Errors',
  qnbr: 'Qualities',
  viewingtime: 'Viewing time',
  viewers: 'Viewers',
  meanvd: 'Mean viewing duration',
  topq: 'Top quality %',
  bitrate: 'Bitrate',
  rebuff: 'Rebuffering %',
  eff: 'Efficiency %',
  dataout: 'Data out',
  dataoutp: 'Data out by viewers',
  energy: 'Energy saved %',
  KWh: 'KWh spent',
  carbon: 'Carbon rejected',
  tags: 'Tags',
  logout: 'Log out of QUANTEEC',
  logouttxt: 'Please confirm you want to log out of QUANTEEC.',
  logoutbtn: 'Log out',
  cancel: 'Cancel',
  vidprev: 'Video preview',
  titlevid: 'Title of the video',
  authorvid: 'Author of the video',
  novideos: 'No videos',
  none: 'None',
  typelive: 'Type of live video',
  numberarch: 'Number of archives',
  numbercut: 'Number of cut-versions',
  chapterpresence: 'Presence of chapters',
  videotype: 'Video type',
  dwnlfeature: 'Downloadable feature',
  uploadper: 'Upl. %',
  encodingper: 'Enc. %',
  uploadETA: 'Upl. ETA',
  encodeETA: 'Enc. ETA',
  allvids: 'All ',
  sortedby: ' videos sorted by ',
  filtered: 'filtered with ',
  sby: ' sorted by',
  legend: 'Legend',
  ongoingl: 'Ongoing Live',
  lstopped: 'Live stopped',
  vod: 'VOD',
  archive: 'Archive',
  cutversion: 'Cut-version',
  lwarch: 'Live w/ Archives (imb. mode)',
  vodwcut: 'VOD w/ Cut-versions (imb. mode)',
  archwcut: 'Archive w/ Cut-versions (imb. mode)',
  selected: 'Selected: ',
  show: 'Show',
  hide: 'Hide',
  selectall: 'Select all',
  last: 'Last',
  by: 'By',
  top: 'Top',
  playable: '(playable)',
  encoding: 'encoding',
  uploading: 'uploading...',
  uploadfailed: 'upload failed',
  restarting: 'restarting...',
  stopped: 'stopped',
  encoded: 'encoded',
  error: 'error',
  waiting: 'waiting...',
  deletenow: 'The video will be deleted now',
  nodate: 'No date',
  watch: 'Watch',
  videod: 'Video(s) deletion',
  delete: 'Delete',
  confirmd: 'Please confirm the deletion of video: ',
  confirmdall: 'Please confirm the deletion of <strong>all</strong> selected videos.<br /><br /> Make sure they are not linked to Projects.<br /> The videos cannot be recovered.',
  confirmd2: 'Make sure this video is not linked to one (or more) Project(s). <br />The video cannot be recovered.',
  processingvids: 'Video(s) processing restart',
  customQ: 'Custom qualities',
  relaunch: 'Re-launch process',
  relaunchconfirmall: 'Please confirm the re-launch of the encoding process of <strong>all</strong> selected videos.',
  relaunchconfirm: 'Please confirm the re-launch of the encoding process of ',
  modifyencp: 'Modify encoding parameters',
  nodelayo: 'No-delay only (5 viewers max.)',
  mixdelay: 'No-delay for 5 first viewers + low-delay for the others',
  lowdelay: 'Low-delay only (large audience)',
  qencmethod: 'Qualities encoding method',
  defaultenc: '(default/recommended)',
  pttext: 'Make the video immediately available to viewers in passthrough while the encoding is being performed (which will be - at minimum - the duration of the video). <br />Once finalised, the encoded versions will automatically replace the passthrough one.',
  confbelow: '(configure below)',
  sameaso: '(same as original, no additional quality)',
  addq: 'Add a quality and adjust your parameters*',
  addqe: 'Add a quality to encode',
  specificQ: '*For very specific encoding parameters, please contact QUANTEEC at: support@quanteec.com',
  encprocstop: 'Encoding process stop',
  encprocstopconf: 'Please confirm the stop of the re-encoding process of',
  stopproc: 'Stop process',
  videoprocresterr: 'Video(s) processing restart: <span style="color:red">error</span>',
  restartliveserr: 'You can not restart several lives from your webcam at once.',
  iframecode: 'Video iFrame Code',
  iframecodetxt: 'iFrame code of video', 
  clip: ' is copied to Clipboard.',
  directlink: 'Video direct link',
  directlinktxt: 'Direct link of video: ',
  delayeddesplan: 'Delayed destruction: planification',
  delayeddesplantxt: 'Please confirm planification of the destruction of <strong>all</strong> selected videos for ',
  delayedreason: 'The entered date is prior/close to current time. The selected videos will be immediately deleted.',
  confirm: 'Confirm',
  close: 'Close',
  delayedtime: 'The video(s) will be deleted at the specified date/time - error(s): ',
  delayeddeserr: 'Delayed destruction: <span style="color:red">error</span>',
  delayeddeserr2: 'Error trying to plan the deletion of video ',
  delayeddesclear: 'Delayed destruction: clear dates',
  delayeddescleardates: 'The deletion dates of the selected videos have been cleared - error(s): ',
  delayeddescleardateserr: 'Delayed destruction: clear dates <span style="color:red">error</span>',
  delayeddescleardateserrtxt: 'Error trying to clear the date for a planned deletion of video',
  //PLAYERPAGE
  projectsuv: 'Project(s) using this video*',
  desc: 'Description:',
  currentv: 'Current version:',
  createnp: 'Create a new Project from this video',
  onlyp: '*Only projects you are involved in are shown here.',
  videoinfos: 'Video infos',
  totalld: 'Total live duration',
  type: 'Type',
  ongoingls: 'Ongoing Live stream',
  vodcp: 'VOD, currently processing...',
  ls: 'Live stream',
  archivefl: 'Archive from Live',
  livess: 'Live stream, stopped',
  vodff: 'Video from file',
  livess30: 'Live stream, starting (up to 30s)...',
  vodupl: 'Video from file, uploading...',
  liveerr: 'Live stream, error',
  voderr: 'VOD, error',
  livespro: 'Live stream, processing...',
  vodpro: 'VOD, processing...',
  fromc: 'From camera',
  fromss: 'From streaming soft',
  customs: 'Custom stream',
  keptasvod: 'Kept as VOD',
  notkeptasvod: 'NOT kept as VOD',
  vodarchivestxt: '<b>VOD Archives</b> are automatically created each time you stop the stream or when no input is received for 1min. There are no restrictions in re-launching the stream, after it is stopped.',
  changingpara: 'Changing this parameter while in <span style="color:#ba0000">encoding</span> mode restarts the encoding process. The stream will not be available for 30s minimum. <br />This feature uses your storage.',
  createnewVODs: 'Create new VODs from the original with different timeframes in two different modes:<br><b>Accurate</b> mode: the video will respect exactly the timeframe entered but its creation will last at minimum the duration of the video.<br><b>Fast</b> mode: the video will respect approximately the timeframe entered - it may vary up to a few seconds - but its creation will be almost instanteneous.',
  existingcv: 'Existing cut-versions',
  start: 'Start:',
  end: 'End:',
  accurate: 'Accurate',
  fast: 'Fast',
  cutsmode: 'Cut-versions mode',
  accuratemodetxt: '<b>Accurate</b> mode: the video will respect exactly the timeframe entered but its creation will last at minimum the duration of the video.<br><b>Fast</b> mode: the video will respect approximately the timeframe entered - it may vary up to a few seconds - but its creation will be almost instanteneous.',
  existingVODa: 'Existing VOD archives',
  downlallo: 'Download is allowed for all VOD archives',
  downlnotallo: 'Download is NOT allowed for all VOD archives',
  starting: 'starting',
  custom: 'Custom',
  qualityaso: 'Quality (as original)',
  qualities: 'Qualities:',
  copy: 'Copy',
  copied: 'Copied',
  sourcec: 'Source connected',
  sourcedis: 'Source disconnected',
  time: 'Time:',
  videobr: 'Video bitrate:',
  audiobr: 'Audio bitrate:',
  modifyes: 'Modify external streams',
  startstr: 'Start streams',
  stopstr: 'Stop streams',
  extstrstat: 'Global external streams status:',
  disnevstart: 'Disconnected - never started',
  liveperlivestat: 'Individual ext. Live status (updates may take a few seconds):',
  connected: 'Connected',
  disconnected: 'Disconnected',
  customwm: 'Custom watermark text:',
  iframecode: 'iFrame code:',
  iframecodetxt: 'Code of the iFrame for integrating a responsive player for this video into a html page.',
  directl: 'Direct link:',
  directltxt: 'Direct link to a webpage integrating a responsive player for this video.',
  exportl: 'Export Link',
  exportltxt: 'Code of the iFrame for integrating a responsive player for this export link into a html page.',
  manageel: 'Manage export links',
  videoparam: 'Video parameters',
  plandst: 'Plan delayed start on: ',
  plandsttxt: 'The video is planned to be made available to viewers on:',
  fromthecre: 'From the creation',
  selectdate: 'Select a date',
  setup: 'Setup',
  modify: 'Modify',
  clear: 'Clear',
  selectdateprior: 'The selected date is prior (or equal) to the actual time. The video will be immediately made available.',
  videodel: 'The video will be deleted before it will be made available to viewers.',
  plandd: 'Plan delayed destruction:',
  videoplandd: 'The video is planned to be automatically destroyed on:',
  nodates: 'No date specified',
  selectdatedel: 'The selected date is prior (or equal) to the actual time. The video will be immediately deleted.',
  videoselectdatedel: 'The video will be deleted before it will be made available to viewers.',
  chatliveact: 'The live chat will be activated on this video',
  chatlivedesact: 'The live chat will NOT be activated on this video',
  passwdprot: 'The video is password-protected',
  passwdnotprot: 'The video is NOT password-protected',
  modifypwd: 'Modify password',
  removepwd: 'Remove password',
  addpwd: 'Add password',
  viewersauth : 'Viewers are authorized to seek back during Live session - unavailable for no-delay viewers',
  viewersnotauth: 'Viewers are NOT authorized to seek back during Live session',
  nbrofstk: 'Number of seconds to keep (min: 30 - max: 600):',
  videodwnl: 'The video can be downloaded',
  videonotdwnl: 'The video can NOT be downloaded',
  videoautolaunch: 'The video is automatically launched for viewers (but muted)',
  videonotautolaunch: 'The video is NOT automatically launched for viewers. They must press the play button.',
  videointromodal: 'Informations are displayed at the beginning of the video',
  videonotintromodal: 'Informations are NOT displayed at the beginning of the video',
  modifyct: 'Modify custom thumbnail',
  custimizet: 'Customize thumbnail',
  removect: 'Remove custom thumbnail',
  chapters: 'Chapters: ',
  chapter: 'chapter(s)',
  nochapter: 'No chapters',
  uplchapter: 'Upload a chapter file',
  addchapman: 'Add a chapter manually',
  vodacc: 'VoD(s) from my accelerated live',
  dnwlQP: 'Download video in Quanteec Platform',
  videoshar: 'Video sharing',
  videoanalytics: 'Video analytics',
  sourcePathModified: 'The live source has been modified. Please restart the encoding process and the external streams (to Youtube, Facebook, etc.) to make it effective.',
  //ANALYTICS
  videos4all: 'Video(s) - * for all',
  byid: 'By ID',
  or: 'or',
  selectvid: 'Select video(s)',
  interval: 'Interval:',
  timerange: 'Time range:',
  views: 'Views',
  allvids2: '- all videos',
  ofthetime: 'of the time in highest quality',
  ofeff: 'of efficiency',
  ofener: 'of energy saved',
  viewersmax: 'viewers max',
  totalvt: 'Total view. time',
  maxavgv: 'Max avg. viewers*',
  maxavgcv: 'Max avg. viewers*',
  plays: 'Plays',
  meanvt: 'Mean view. time',
  viewersvalues: '*"Viewers" values are displayed as an average of the number of concurrent viewers during the interval. Reduce the interval to have a more precise value.',
  meanvtvalues: '"Mean viewing time" values are computed related to the time range chosen.',
  quality: 'Quality',
  highq: 'High qualities %*',
  highqdata: 'High qualities data*',
  lowqdata: 'Low qualities data*',
  avgvb: 'Avg. video bitrate',
  rebuffering: 'Rebuffering %',
  rebuffmin: 'Rebuffering minutes',
  playedmin: 'Played minutes',
  videodata: '*Video data are considered of high quality if the current quality resolution is higher than the current screen size or if the current quality is the best quality available for the video.',
  efficiency: 'Efficiency*',
  effnote: '*The efficiency is the % of data received from other viewers over the total data received.',
  effdata: 'Efficiency %',
  effdataco: 'Efficiency - connected viewers',
  efftime: 'Efficiency % (time)',
  totaldatadel: 'Total data delivered',
  delfromp: 'From viewers',
  delfroms: 'From CDN',
  ener: 'Energy*',
  energynote: '*All the data related to energy are estimates based on recommandations from below research studies.',
  energynote2: 'Basis: worldwide data. For Europe, divide carbon values by 1.6. For France, divide carbon values by 7.',
  lightexp: ' - equivalent to the energy saved by turning off <span style="color:#14BF98;font-weight:bold">1</span> 30-Watts bulb during one hour.',
  houseexp: ' - equivalent to the energy saved by turning off all electricity consumed by <span style="color:#14BF98;font-weight:bold">1</span> household during one day.',
  enersaved: 'Energy saved %',
  connview: 'Connected viewers only',
  poweren: 'Energy consumed',
  delivery:'(delivery)',
  powerens: 'Energy saved',
  powerend: 'Energy consumed',
  viewing: '(viewing)',
  co2rej: 'CO2 rejected',
  co2saved: 'CO2 saved',
  watercon: 'Water consumed',
  watersav: 'Water saved',
  selectvidana: 'Select videos to display their analytics',
  viewtimemobile: 'View. time - mobile',
  viewtimetablet: 'View. time - tablet',
  viewtimedesktop: 'View. time - others',
  viewtimeeth: 'View. time - other nets',
  viewtimecellular: 'View. time - cell nets',
  map: 'Viewers data map',
  //EXPORT LINKS
  newel: 'New Export Link',
  copyonelink: 'Copy <span style="color:#14BF98">one link</span>, share the <span style="color:#14BF98">videos</span> you want.',
  exportvids: 'Export your videos to your website using QUANTEEC customizable <strong style="color:#14BF98">EXPORT LINKS</strong>.',
  exportlink: '<strong style="color:#14BF98">EXPORT LINKS</strong> allows you to copy a single and valid link into your personal website or web application. Then, you can come back to this page to modify the video associated with your single link.',
  exportl: 'export link(s)',
  exportl1: 'Export Link',
  copytc: 'Copy this code and put it in your html page to export a responsive player for the associated video',
  videolinked: 'Video linked:',
  novideolinked: 'No video linked',
  dissociate: 'Dissociate a video',
  deletel: 'Delete Export Link',
  associate: 'Associate a video',
  errorposttxt: 'This new export link cannot be created. Please retry later or contact QUANTEEC at support@quanteec.com.',
  errorgettxt: 'The list of export links cannot be retrieved. Please retry later or contact QUANTEEC at support@quanteec.com.',
  errorputtxt: 'The export link cannot be updated. Please retry later or contact QUANTEEC at support@quanteec.com.',
  errordeltxt: 'The export link cannot be deleted. Please retry later or contact QUANTEEC at support@quanteec.com.',
  viddel: 'Export Link deletion',
  confirmdel: 'Please confirm the deletion of ',
  linkrecnot: 'The link cannot be recovered.',
  selectel: 'Select a video stream to associate to Export Link:',
  videoifcode: 'Video iFrame Code of Export Link',
  ifcodeel: 'iFrame code of Export Link for video: ',
  iscopied: 'is copied to Clipboard.',
  //PROFIL
  product: 'PRODUCT',
  freetier: 'Free-Tier account. Limited to 1TB of streaming. No guaranteed ressources.',
  upgrade: 'Upgrade now',
  viewingt: 'Viewing Time:',
  viewsp: 'Views:',
  datadel: 'Data delivered:',
  peradd: 'per additional',
  storagep: 'Storage:',
  concenc: 'Concurrent encodings:',
  basep: 'Base price:',
  
  meanvtp: 'Mean viewing time per session:',
  clientinfo: 'CLIENT INFORMATION',
  clientnbr: 'Client Number:',
  contractnbr: 'Contract Number:',
  companyname: 'Company Name:',
  siret: 'SIRET:',
  contactname: 'Contact Name:',
  contact1stname: 'Contact First Name:', 
  email: 'Email:',
  phone: 'Phone:',
  postaladdr: "Postal address:",
  accountinfo: 'ACCOUNT INFORMATION',
  username: 'Username:',
  invalidemail: 'Invalid email format',
  enterpass: 'Enter your password to change your email',
  updateemail: 'Update Email',
  newpass: 'New password*:',
  enternpass: 'Enter your new password',
  pass7: 'Passwords must contain at least: 7 characters, one lower letter, one upper letter, one digit and one special character.',
  confirmpass: 'Confirm your new password',
  passident: 'Passwords must be identical',
  enterold: 'Enter your old password to validate your changes',
  updatepass: 'Update password',
  wishalert: 'I wish to receive alert emails in case of error(s)',
  wishnotalert: 'I do NOT wish to receive alert emails in case of error(s)',
  apidoc: 'API documentation',
  collab: 'COLLABORATORS',
  createcollab: 'Create a new collaborator',
  docs: 'DOCUMENTS',
  bills: 'Bills:',
  odocs: 'Other documents:',
  unsub: 'UNSUBSCRIBE',
  deleteclient: 'Delete client account and all data',
  deleteclienttxt: 'The deletion of your account and all your data is planned to be effective within the next 48 hours. Click the button below if you changed your mind.',
  canceldel: 'Cancel deletion and keep client account & data',
  collabdel: 'Collaborator deletion',
  confirmcollabdel: 'Please confirm the deletion of collaborator:',
  makesure: 'Make sure this collaborator is not linked to one or more Projects.',
  norecover: 'The collaborator cannot be recovered.',
  claccdel: 'Client account deletion',
  claccdelconfirm: 'Please confirm the deletion of your client account and all your data (collaborators, videos and projects). <br>All will be deleted within the next 48 hours.<br /><br /> If you change your mind, please contact us at the following email address: <span style="color: #2F90B0">contact@quanteec.com</span> (or click the "keep account" button on your Profile page).',
  passwdmodif: 'Password modification',
  passwdmodiftxt: 'The password has been correctly modified.',
  errpassmod: 'Error password modification',
  errpassmodtxt: 'The password has not been correctly saved. Please retry later or contact Quanteec at: contact@quanteec.com',
  erroldpass: 'Error password or email modification',
  erroldpasstxt: 'Your current password is incorrect. Your password or email have not been modified.',
  keepclacc: 'Keep client account',
  keepclacctxt: 'Please confirm that you want to keep your account.',
  erremail: 'Error email',
  erremailtxt: 'This email address is already used by another account.',
  erremailtxt2: 'Error in email change.',
  verifemail: 'Verification email sent',
  verifemailtxt: 'A verification email has been sent. <br><br>Please validate the new email in order to use QUANTEEC services with it. It is valid 24h.',
  newcollab: 'New collaborator creation',
  param: 'DEFAULT PARAMETERS',
  titledp: 'These parameters will be used by default when creating a new video',
  //USER FORM
  collab1: 'Collaborator',
  collabname: 'Enter collaborator name',
  collabemail: 'Enter collaborator email',
  randompass: '*A random generated password will be sent by email',
  accmgrrights: 'Full rights on all features for account, collaborators and all videos',
  videomgrrights: 'Full rights on all features related to the videos only',
  addcollab: 'Add a new collaborator',
  createcollab: 'Create',
  reset: 'Reset',
  errcollabc: 'Error collaborator creation',
  errcollabctxt: 'Cannot create the new collaborator. Please try again later or contact QUANTEEC at: support@quanteec.com.',
  errcollabcemailtxt: 'This email is already used by a collaborator.',
  errcollabcunametxt: 'This username <span style="color: #2F90B0"><strong>{{newCollaborators}}</strong></span> is already taken.<br />You can use <span style="color: #2F90B0"><strong>{{newCollaborators}}</strong></span> instead.',
  newcollabc: 'New collaborator created',
  newcollabctxt: 'Collaboradzedztor <span style="color: #2F90B0"><strong>{{newCollaborators}}</strong></span> has been successfully created. <br /><span style="color: #2F90B0"><strong>{{newCollaborators}} </strong></span> will receive an email with his credentials.',
  //VIREED TEAM
  teams: 'TEAMS',
  norights: 'No rights to modify',
  createnewt: 'Create new team',
  teaminfos: 'Team Infos',
  teamembers: 'Team Members',
  addtotheteam: 'Add to the Team',
  create: 'Create',
  reset: 'Reset',
  teaminfos: 'Team Information',
  members: 'Members',
  teamdel: 'Team deletion',
  teamdeltxt: 'Please confirm the deletion of Team:',
  teamdeltxt2: 'Make sure this team is not linked to one or more Projects.<br> The team cannot be recovered.',
  alreadym: 'is already a member of this team.',
  //PLUGIN DOC
  yourpersonalkey: 'Your personal QUANTEEC Key to be used for all your videos:',
  videoplayerdoc: 'Video player doc',
  visualizationtooldoc: 'Visualization tool doc',
  needacdn: 'Need a CDN ?',
  selectvideoplayer: 'Select the video player to integrate QUANTEEC in',
  watchonce: 'Once done, please make sure to watch at least once the video to have it appear under Videos tab',
  brightcovecodep1: 'Screenshots of Brightcove Player configuration to integrate <strong> QUANTEEC</strong>',
  pluginp1: 'Retrieve <strong>QUANTEEC</strong> js file from <a href="https://files.quanteec.com/quanteec/latest/videojs-quanteec-plugin.js" > here </a> for integration within <a href="https://videojs.com">video.js</a>. Then, proceed with the 4 following simple steps:',
  pluginp1_1: 'Retrieve <strong>QUANTEEC</strong> js file from <a href="https://files.quanteec.com/quanteec/latest/quanteec-vhs.min.js" > here </a> for integration within <a href="https://videojs.com">video.js</a>. Then, proceed with the 3 following simple steps:',
  pluginp2: 'Retrieve <strong>QUANTEEC</strong> js file from <a href="https://files.quanteec.com/quanteec/latest/quanteec-hlsjs.min.js" > here </a> for integration within <a href="https://github.com/video-dev/hls.js/">hls.js (from v0.13.2 and +)</a>.Then, proceed with the 3 following simple steps:',
  pluginp3: 'Retrieve <strong>QUANTEEC</strong> js file from <a href="https://files.quanteec.com/quanteec/latest/quanteec-dashjs.min.js" > here </a> for integration within <a href="https://github.com/Dash-Industry-Forum/dash.js/wiki">dash.js (from v2.6.0 and +)</a>. Then, proceed with the 3 following simple steps:',
  pluginp4: 'Retrieve <strong>QUANTEEC</strong> js file from <a href="https://files.quanteec.com/quanteec/latest/quanteec-shaka.min.js" > here </a> for integration within <a href="https://github.com/shaka-project/shaka-player">shaka player</a>. Then, proceed with the 3 following simple steps:',
  pluginp5: 'Retrieve <strong>QUANTEEC</strong> js file from <a href="https://files.quanteec.com/quanteec/latest/quanteec-hlsjs.min.js" > here </a> for integration within <a href="https://flowplayer.com">flowplayer</a> 7.Then, proceed with the 4 following simple steps:',
  pluginp6: 'Retrieve <strong>QUANTEEC</strong> js file from <a href="https://files.quanteec.com/quanteec/latest/quanteec-hlsjs.min.js" > here </a> for integration within <a href="https://flowplayer.com">flowplayer</a> native. Then, proceed with the 5 following simple steps:',
  pluginp7: 'Retrieve <strong>QUANTEEC</strong> js file from <a href="https://files.quanteec.com/quanteec/latest/videojs-quanteec-plugin.js" > here </a> for integration within <a href="https://brightcove.com">Brightcove</a>. Then, proceed with the 3 following simple steps:',
  pluginp8: 'Include the script in your html page',
  pluginp9: 'Include the file videojs-quanteec-plugin.js on the Plugins section, under JavaScript/Javascript URL',
  pluginp10: 'Add <strong>quanteec</strong> on the Plugins section, under Name, Options (JSON)/Plugin Name',
  pluginp11: 'Adjust QUANTEEC configuration to your quanteecKey and specific options',
  pluginp12: 'Link QUANTEEC to video.js object *before* the creation of the videojs player instance',
  pluginp13: 'Register the Quanteec plugin in videojs',
  pluginp14: 'Link QUANTEEC to hls.js right *after* the creation of the hls player instance',
  pluginp1_2: 'Link QUANTEEC to videos player right *after* the creation of the player instance',
  pluginp15: 'Link QUANTEEC to dash.js right *after* the creation of the dash player instance',
  pluginp16: 'Link QUANTEEC to shaka player right *after* the creation of the shaka player instance',
  pluginp17: 'Link QUANTEEC to flowplayer *before* the creation of the flowplayer instance',
  pluginp18: 'Add these parameters in the options of flowplayer',
  pluginp19: 'Declare your flowplayer instance to QUANTEEC to monitor the buffer and provide the most appropriate quality',
  pluginp20: 'Adjust QUANTEEC configuration to your quanteecKey and specific options on the Plugins section, under Name, Options (JSON)/plugin options (formatted as JSON)',
  pluginp21: 'Retrieve <strong>QUANTEEC</strong> js file from <a href="https://files.quanteec.com/quanteec/latest/quanteec-rxplayer.min.js" > here </a> for integration within <a href="https://github.com/canalplus/rx-player">rxPlayer</a>. Then, proceed with the 3 following simple steps:',
  pluginp22: 'Retrieve <strong>QUANTEEC</strong> js file from <a href="https://files.quanteec.com/quanteec/latest/quanteec-bitmovin.min.js" > here </a> for integration within <a href="https://bitmovin.com/video-player/">Bitmovin</a>. Then, proceed with the 3 following simple steps:',
  pluginp23: 'Link QUANTEEC to rxPlayer right *after* the creation of the rxPlayer instance',
  pluginp24: 'Link QUANTEEC to bitmovin right *before* the creation of the bitmovin instance',
  pleaseretry: 'Please retry later',
  plugint1: 'QUANTEEC Visualization tool',
  exampledrm: 'Example with DRM',
  examplenodrm: 'Example without DRM',
  //CDN DOC
  needatradcdn: 'Need a traditional CDN ?',
  cdnagnostic: 'is CDN agnostic and is compatible with all major CDNs in the market. For example :',
  wecanmanage: 'We can also manage a CDN for you with our partner. This CDN usage comes with no additional cost: 10 € / TB.',
  //CDN DOC 2
  programcachetitle: 'Program your cache to optimize your video delivery',
  programcachep1: 'DASH and HLS streaming sessions are composed of two types of files. The <strong>manifest</strong> files (in .mpd or .m3u8) which contains the metadata of the streaming session and the <strong>video</strong> files. While static <strong>video</strong> files can be stored in cache for a long period, <strong>manifest</strong> files are refreshed regularly and must be revalidated after a small period of time, especially for live streaming.',
  programcachet2: 'Recommended cache parameters',
  programcachep2: 'For both <strong style="color:#14BF98">manifest</strong> and <strong style="color:#14BF98">video</strong> files, we recommend to set the <strong>Cache-Control</strong> headers to <strong>must-revalidate</strong> with a <strong>max-age</strong> property. This header tells the web browsers to keep the ressources in memory for a certain amount of time, and then to revalidate the ressource with the server after <strong>max-age</strong> seconds. If the ressource has been modified, the server will answer with a <strong>NOT MODIFIED</strong> response without sending the data. This behaviour optimizes the usage of the cache with displaying up to date data.',
  programcachep3: 'For the <strong style="color:#14BF98">manifest</strong> files, we recommend to revalidate the ressource with a max-age equal to the duration of your smaller segments (in seconds). For example, with 3-seconds video segments:',
  programcachep4: 'For the <strong style="color:#14BF98">video</strong> files, the ressources can be stored in cache for a higher duration, depending on the availability duration of your data.',
  programcachet3: 'Example with Nginx',
  programcachet4: 'Example with Apache',
  // CustomCDN.vue
  originurl: 'Origin url',
  newurl: 'New url',
  cdnprice: 'Price',
  actions: 'Actions',
  TBunit: 'TB',
  cdnblockedips: 'Blocked IP address',
  cdnblockedcountries: 'Blocked Countries',
  cdnwhitelistedwebsites: 'Whitelisted websites',
  cdnblacklistedwebsites: 'Blacklisted websites',
  addcdn: 'Add CDN',
  customcdnp1: 'To stream your video via the CDN, you simply need to replace the URLs pointing to your static files with the <strong>New url</strong> hostname. Your video data will be automatically downloaded, cached and delivered through the CDN.',
  customcdnp2: 'For example, update the video file URLs pointing to:',
  customcdnp3: 'to your <strong>New url</strong> hostname:',
  customcdnp4: 'The videos can be watched from any IP address, EXCEPT the ones on the list below. You can also block the whole subnet using wildcards, for example 91.212.45.*',
  customcdnp5: 'The videos can be watched from any country, EXCEPT the ones on the list below. Use the <a href="https://www.iso.org/obp/ui/fr/#search" target="_blank">ISO 3166 Alpha-2 codes</a>.',
  customcdnp6: 'The video can ONLY be watched from the websites on the list below. You can also allow a whole subdomain like *.quanteec.com.',
  customcdnp7: 'The video can be watched from any website, EXCEPT the ones on the list below. You can also block a whole subdomain like *.quanteec.com.',
  customcdnp8: 'Changes may take a few seconds to come into effect.',
  Submit: 'Submit',
  Success: 'Success',
  selectedtextcopied: 'Selected text copied',
  cachepurged: 'Cache purged. New ressources should be loaded after a few seconds.',
  cdncontractsigned: 'CDN links are limited to registered clients with an active subscription. You can activate your full Quanteec account in your profil page.',
  //PLUGIN PRICE
  priceestcalc: '€ Price estimation calculator',
  enternbrTB: 'Enter number of TBs:',
  price: 'Price:',
  priceperTB: 'Price per TB:',
  producttitle: 'PRODUCT',
  pldatadelivered: 'Data delivered:',
  lastdatadelivered: 'Last month:',
  lastprice: 'Price last month:',
  GBunit: 'GB',
  TBunit: 'TB',
  TBstarted: 'Current month (starting on the 1st). Every TB started is due.',
  currentprice: 'Price:',
  termsofservice: 'Terms & Conditions',
  pricinglist: 'Pricing list',
  accepttermsofservice: 'I accept the Terms & Conditions and prices',
  acceptcontract: 'Generate the contract',
  peradditional: 'per additional',
  contractaccepted: 'Contract generation',
  welcome: 'Welcome to QUANTEEC. Your contract is being generated. It will appear in your Documents section shortly.',
  uploadRIB: 'Please upload or send your bank details at:',
  errorcontract: 'Please retry later or contact Quanteec at:',
  Error: 'Error',
  bankreceived: 'Bank details received',
  rib: 'Bank details:',
  chooseRIB: 'Choose a bank details file...',
  uploadbankdet:'Upload bank details',
  modifybankdetails: 'Bank details received. To modify them, contact Quanteec at:',
  chargedon5: 'This price will be charged on the 5th of next month.',
  restant: 'in',
  nextlevel: 'Next level',
  previousbillings: 'Show previous billings',
  hidebillings: 'Hide consumption history',
  free: 'Free (in demo mode)',
  only: 'Only',
  leftfree: 'left for free',
  enterpaymentdetail: 'Enter payment details',
  billingpanel: 'Billing panel',
  consumptionhistory: 'Consumption history',
  // VISUALIZATION TOOL DOC
  visutoolt1: 'Installation process',
  visutoolp1: 'Retrieve QUANTEEC Visualization Tool js file from <a href="https://files.quanteec.com/vizualisation/latest/quanteec-visualize.min.js" > here</a>. Then, proceed with the 2 following simple steps in the html file where QUANTEEC is already embedded:',
  visutoolli1: 'Include the script in your html page',
  visutoolli2: 'Add a div with "quanteec-visualization-tool" as id in your html page',
  visutoolp2: 'And data + graphs should appear.',
  visutoolt2: 'Customization process',
  visutoolp3: 'According to the size set into your page, you can modify the base font-size of the QUANTEEC Vizualization Tool to fit in, by specifying a custom style.',
  visutoolp4: 'By default, both global metrics and graphs are displayed. It is possible to reduce the size of the graphs by adding the attribute <strong>quanteecShow=“less”</strong>. The graphs are then replaced by a button to display/hide the graphs.',
  visutoolp5: 'It is also possible to fully customize the "quanteec-visualize-tool" div (as any div in css), by e.g., fixing a "max-size" in order to limit its size.',
  //PLUGIN-VIDEO
  last24: 'Qualities and analytics data displayed in each card below are refreshed every 30min and are related to the last 24h: to see them in real-time or over a specific period, go to the Analytics page.',
  pluginvideop1: 'Filter on title and tags by default (if no keyword mentioned).',
  pluginvideop2: 'Keywords for specific search are: title, tags, id, description.',
  pluginvideop3: 'Use \'+\' to cumulate several parameters for one keyword. Ex: tags:football+tennis.',
  pluginvideop4: 'Use a space to make a search combining more than one criteria. Ex: title:MyMovie tags:vacation+summer.',
  pluginvideoplural: 'video(s)',
  pluginvideoauthip: 'Authorized IPs:',
  pluginvideounauthip: 'Non-authorized IPs:',
  pluginvideoauthcountry: 'Authorized countries:',
  pluginvideounauthcountry: 'Non-authorized countries:',
  smallnone: 'none',
  pluginvideoice: 'ICE config:',
  pluginvideolocalnet: 'Local network only',
  pluginvideothumbnail: 'Custom Thumbnail URL:',
  pluginvideoauthorizations: 'Authorizations:',
  pluginvideostreamed: 'The video will be streamed',
  pluginvideonotstreamed: 'The video will not be streamed',
  pluginvideoauthip2: 'Authorized IP @ ',
  pluginvideounauthip2: 'Unauthorized IP @',
  pluginvideop5: 'The video can ONLY be watched from the IP addresses on the list below. <br />If empty, the video can be watched from any IP address.',
  pluginvideop6: 'The video can be watched from any IP address, EXCEPT the ones on the list below.',
  pluginvideoauthcountry2: 'Authorized countries',
  pluginvideounauthcountry2: 'Unauthorized countries',
  pluginvideop7: 'The video can ONLY be watched from the countries on the list below. <br />If empty, the video can be watched from any country. Use the <a href="https://www.iso.org/obp/ui/fr/#search" target="_blank">ISO 3166 Alpha-2 codes</a>.',
  pluginvideop8: 'The video can be watched from any country, EXCEPT the ones on the list below. Use the <a href="https://www.iso.org/obp/ui/fr/#search" target="_blank">ISO 3166 Alpha-2 codes</a>.',
  pluginvideowhitewb: 'Whitelisted websites',
  pluginvideoblackwb: 'Blacklisted websites',
  pluginvideop9: 'The video can ONLY be watched from the websites on the list below. <br />If empty, the video can be watched from any website.',
  pluginvideop10: 'The video can be watched from any website, EXCEPT the ones on the list below.',
  pluginvideoiceconf: 'ICE Configuration:',
  pluginvideodefault: 'QUANTEEC (default)',
  pluginvideoicecustom: 'Custom ICE configuration',
  pluginvideobound: 'Bound to default authorizations',
  pluginvideoisauthst: 'authorized for streaming',
  pluginvideoisnotauthst: 'not authorized for streaming',
  videopluginvpn: 'VPNs and proxies authorized',
  videopluginnotvpn: 'VPNs and proxies not authorized, except:',
  pluginvideoenterurlthumb: 'Enter the URL of the thumbnail',
  pluginvideoisauthorized : 'Authorized for streaming',
  pluginvideoisnotauthorized: 'Not authorized for streaming',
  pluginvideoisvpn: 'VPNs and proxies are authorized',
  pluginvideoisnotvpn: 'VPNs and proxies are not authorized, except:',
  pluginvideoaddstun: 'Add STUN',
  pluginvideoaddturn: 'Add TURN',
  pluginvideovalidate: 'Validate',
  pluginvideoresetdefault: 'Reset to Default',
  // PAYMENT SUCCESS
  successpayment: 'Payment success',
  paymentsuccessp1: 'You can start using QUANTEEC.',
  failurepayment: 'Payment failure',
  paymentfailurep1: 'An error occured during the payment, or the payment has been abandonned. You can use QUANTEEC up to the free tier volume. If you had an issue with the payment, please contact QUANTEEC at',

  supportedDRM : 'QUANTEEC supports the following DRMs:',

  resetTags : 'Reset tags',
  //OUTRO
  modifyoutro: 'Modify outro',
  removeoutro: 'Remove outro',
  outro: 'Outro',
  outrotitle: "Title",
  outrodescription: "Description",
  outrourl: "Link button",
  outrotext: "Button text",
  outroimg: "Image",
  outrourl2: "Link subtext",
  outrotext2: "Subtext",
  backgroundoutro: "Background image",
  outrocurrentimg: "Current outro image",
  helptag:"Help with tags",
  helptagtxt:"Filter videos by tags by clicking on them.<br />  Tags in <strong>blue</strong> are ignored in the search.<br/> Tags in <strong>green</strong> mean that they are selected for the search, it will display the videos that contain one or more of these tags.<br /> Tags in <strong>red</strong> mean that they are excluded from the search, the videos with one or more of these tags will not appear.",
  generatethumbnailfrompicture: "Generate a thumbnail at this duration of the video",
  createthumbnail: "Create thumbnail",
  errorcreatethumbnail: "Error during thumbnail generation. Please retry later.",
  successcreatethumbnail: "The new thumbnail has been generated",
  adddefaultoutro: "Add a preconfigured outro",
  addnewoutro: "Add a new outro",
  outrodeleteconfirm: "Are you sure you want to remove this outro ? Removed outros can not be retrieved.",
  outrodeleteerror: "Error during the deletion. Please retry later.",
  // Pictures
  picturestitle: "BANK OF PICTURES",
  picture: "Picture",
  pictureuploadsuccess: "The new picture has been uploaded with success",
  pictureuploaderror: "Error during the upload. Please retry later.",
  picturedeleteconfirm: "Are you sure you want to remove this picture ? Removed pictures can not be retrieved.",
  picturedeleteerror: "Error during the deletion. Please retry later.",
  addapicture: "Add a picture",

  // APIKEY
  apikeystitle: "API KEYS",
  apikey: "Api Keys",
  apikeyuploadsuccess: "The new api key has been added with success",
  apikeyuploaderror: "Error during the creation. Please retry later.",
  apikeydeleteconfirm: "Are you sure you want to remove this api key ? Removed api keys can not be retrieved.",
  apikeydeleteerror: "Error during the deletion. Please retry later.",
  addaapikey: "Add an api key",
  createapikey: "Add an api key",
  // DEFAULT OUTRO
  defaultoutrotitle: "OUTRO COLLECTION",
  addanoutro: "Add a default outro",
  modifyoutro: "Modify selected outro",
  //REPLACE
  replacevideo: "Replace the video",
  // PLATFORM PRICE
  month: "month",
  storage: "Storage:",
  datadelivered: 'Data delivered:',
  concurrentencodings: 'Concurrent encodings:',
  baseprice: "Base price:",
  pricethismonth: 'Price this month:',
  bulbsText: 'Equivalent to: ',
  bulbs: 'lightbulbs ',


}

export {english}